export default __webpack_public_path__ + "static/media/oxxo.2d1445ed.png";